import { Grid } from '@elliemae/ds-grid';
import { PageHeaderTitle } from '@elliemae/ds-page-header';
import { DSPageHeaderV2 } from '@elliemae/ds-page-header';

interface HeaderProps {
  titleText: string;
}
export const CommonHeader: React.FC<HeaderProps> = ({ titleText }) => {
  const today = new Date();
  const formattedDate = new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(today);

  const pageTitle = () => (
    <PageHeaderTitle>
      <span>{titleText} </span>
      <span style={{ position: 'absolute', right: '10px' }}>
        {formattedDate}
      </span>
    </PageHeaderTitle>
  );
  return (
    <Grid style={{ position: 'relative', minHeight: '48px', width: '100%' }}>
      <DSPageHeaderV2 PageTitle={pageTitle} />
    </Grid>
  );
};
